<template>
<div class="store-card-box">
  <div class="store-card">
    <img v-lazy="$cvWebpFn(store?.storeIcon || useImg1pxBase64().value)" alt="" class="store-icon">
    <div class="store-info">
      <p class="store-title">{{ store?.name }}</p>
      <!-- authType: 1: 官方店铺，2: 品牌授权店 -->
      <img v-if="store?.authType === 1" class="store-tag" :src="$cvWebpFn(OFFICIAL_STORE_BADGE_URL)" alt="Brand Official" />
      <img v-else-if="store?.authType === 2" class="store-tag" :src="$cvWebpFn(AUTHORIZED_STORE_BADGE_URL)" alt="Brand Authorized" />
      <img v-if="store?.tags?.includes('store_preferred')" class="store-tag" :src="$cvWebpFn(PREFERRED_STORE_BADGE_URL)" alt="Preferred Store" />
    </div>
  </div>
  <div class="store-info-list">
    <div class="info-item">
      <div class="info-val">{{ store?.starRating || 5 }}</div>
      <div class="info-desc">Score</div>
    </div>
    <div class="info-item">
      <div class="info-val">{{ store?.products }}</div>
      <div class="info-desc">All Products</div>
    </div>
  </div>

  <div class="opt-bar">
    <div class="opt-btn" @click="handleToStoreClick(store?.storeAlias|| store?.id)">
      <van-icon name="shop-o" />&nbsp;Visit Store
    </div>
    <div class="opt-btn" @click="handleToChatClick">
      <van-icon name="chat-o" />&nbsp;Chat Seller
    </div>
  </div>
</div>
</template>

<script setup lang="ts">
const OFFICIAL_STORE_BADGE_URL = 'https://image.kilimall.com/c/h5/ic_official_store.png'
const AUTHORIZED_STORE_BADGE_URL = 'https://image.kilimall.com/c/h5/ic_authorized_store.png'
const PREFERRED_STORE_BADGE_URL = 'https://image.kilimall.com/c/h5/ic_preferred_storex.png'

defineProps<{ store?: Store.IStore }>()
const emits = defineEmits<{(event: 'to:chat'): void}>()

const router = useRouter()
const route = useRoute()

const handleToChatClick = () => {
  if(!useUserInfo().value?.accessToken) {
    router.push(`/login?redirect=${encodeURI(route.fullPath)}`)
  } else {
    emits('to:chat')
  }
}
const handleToStoreClick = (id?: number | string) => {
  id && router.push({ path: `/store/${id}`, query: { first_page: 'productDetail' } })
}
</script>

<style lang="scss" scoped>
.store-card-box{
  padding: 30px 0px;
}
.store-card{
  display: flex;
  @include center();
}
.store-icon{
  width: 72px;
  min-width: 72px;
  height: 72px;
  object-fit: contain;
}
.store-info{
  flex: 1;
  padding: 0 20px;
  .store-title{
    font-weight: 600;
    margin-top: 5px;
    font-size: 28px;
  }
  .product-total{
    color: #999;
    font-size: 24px;
  }
}
.store-info-list{
  display: flex;
  flex-wrap: nowrap;
  padding: 20px 0;
  .info-item{
    flex: 1;
    text-align: center;
    border-right: 1px solid #cacaca;
    &:last-child{
      border: none;
    }
    .info-val{
      color: #150000;
      font-size: 30px;
    }
    .info-desc{
      margin-top: 8px;
      color: #666666;
      font-size: 24px;
    }
  }
}
.opt-bar{
  display: flex;
  @include center();
  .opt-btn{
    width: 248px;
    height: 60px;
    line-height: 60px;
    font-size: 26px;
    border-radius: 30px;
    border: 1px solid var(--default_color);
    color: var(--default_color);
    @include center();
    margin: 20px 20px 0 20px;
    i{font-size: 38px;}
  }
}
.store-tag {
  display: inline-block;
  width: auto;
  height: 32px;
  margin-top: 10px;
  & + .store-tag {
    margin-left: 10px;
  }
}
</style>
